import { queryNetCompany } from '@/services/company';

export default {
  namespace: 'NightclubSkin_company',

  state: {
    data: {},
  },

  effects: {
    *fetchNet({ payload }, { call, put }) {
      const { status, data } = yield call(queryNetCompany, payload);

      if (status === 200) {
        yield put({
          type: 'save',
          payload: {
            list: data.data,
            pagination: {
              total: data.meta.total,
              pageSize: data.meta.per_page,
              current: data.meta.current_page,
            },
          },
        });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
  },
};
